import { createContext, useState, useEffect, useContext } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'de';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.title = language === 'de'
      ? 'Culture Cracker® — Kein Spiel. Ein Diagnose-Mechanismus.'
      : 'Culture Cracker® — Not a Game. A Diagnostic Mechanism.';
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => setLanguage(l => l === 'de' ? 'en' : 'de');

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
export default LanguageContext;
